module.exports = __webpack_public_path__ + "static/media/heart_percent.5d1f9b09.png";